// extracted by mini-css-extract-plugin
module.exports = {"Container":"Navbar_Container__2TAEu","Open":"Navbar_Open__1oun2","LanguageSwitcher":"Navbar_LanguageSwitcher__2bEPY","CloseBtn":"Navbar_CloseBtn__3HPDh","Nav":"Navbar_Nav__mg1uk"};